"use client";

import localFont from "next/font/local";
import "./globals.css";
import { SessionProvider } from "@/lib/SessionProvider";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PHProvider } from "@/lib/providers";
import dynamic from "next/dynamic";
import { I18nextProvider } from "react-i18next";
import i18n from "@/lib/i18n/i18next.config";
import { ChatbotProvider } from "@/lib/ChatbotContext";

const PostHogPageView = dynamic(() => import('./PostHogPageView'), {
  ssr: false,
});

const geistSans = localFont({
  src: "./fonts/GeistVF.woff",
  variable: "--font-geist-sans",
  weight: "100 900",
});

const geistMono = localFont({
  src: "./fonts/GeistMonoVF.woff",
  variable: "--font-geist-mono",
  weight: "100 900",
});

const queryClient = new QueryClient();

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html>
      <head>
        <title>MTLEmpresas</title>
        <meta name="description" content="MTLEmpresas - Employee Evaluation Platform" />
      </head>
      <body className={`${geistSans.variable} ${geistMono.variable} antialiased`}>
        <PHProvider>
          <ChatbotProvider>
            <I18nextProvider i18n={i18n}>
              <QueryClientProvider client={queryClient}>
                <PostHogPageView />
                <SessionProvider>
                  {children}
                  <Toaster />
                </SessionProvider>
              </QueryClientProvider>
            </I18nextProvider>
          </ChatbotProvider>
        </PHProvider>
      </body>
    </html>
  );
}
